import { Link } from 'react-router-dom';
import AuthService from '../services/auth.service';

export const linkTo = (path: string, id: string, text: string, target?: string) => {
  return (
    <Link title={text} to={`${path}/${id}`} target={target || '_self'}>
      {text}
    </Link>
  );
};

export const authorizedLinkTo = (permission: string, path: string, text: string, target?: string) => {
  return AuthService.hasPermission(permission) ? (
    <Link title={text} to={`${path}`} target={target || '_self'}>
      {text}
    </Link>
  ) : (
    text
  );
};
